import { render, staticRenderFns } from "./ReportPeritiIspettore.vue?vue&type=template&id=35458d0a"
import script from "./ReportPeritiIspettore.vue?vue&type=script&lang=js"
export * from "./ReportPeritiIspettore.vue?vue&type=script&lang=js"
import style0 from "./ReportPeritiIspettore.vue?vue&type=style&index=0&id=35458d0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports